import React from 'react';
import classNames from 'classnames';
import i18next from 'i18next';
import { CoreLink } from '@uncinc/react-drupal-core';
import { WysiwygField, Image } from '@uncinc/uncinc-react-kitchen-sink';
import { getPathFromAlternativePaths } from '../../../../helpers';

import './style.scss';

const DownloadTeaserLarge = ({ entity, className, direction }) => {
  const classes = classNames(className, [
    'DownloadTeaserLarge',
    direction === 'right' ? 'reversed' : null,
  ]);
  const url = getPathFromAlternativePaths(entity, ['download', 'download']);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink to={url} className="overlapping-link" />
      <div className="DownloadTeaserLarge__content">
        <div className="DownloadTeaserLarge__imageWrapper">
          <Image
            alt={entity.getIn(['field_teaser_media', 0, 'title'], '')}
            lazyload={false}
            src={entity.getIn(['field_teaser_media', 0, 'styles', 'teaser_square'], '')}
            className="DownloadTeaserLarge__imageNormal"
          />
          <Image
            alt={entity.getIn(['field_teaser_media', 0, 'title'], '')}
            lazyload={false}
            src={entity.getIn(['field_teaser_media', 0, 'styles', 'teaser'], '')}
            className="DownloadTeaserLarge__imageMobile"
          />
        </div>
        <div className="DownloadTeaserLarge__contentWrapper">
          <div className="node--sub-heading">
            <div className="node--sub-heading node--sub-heading--with-labels">
              {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value']) ? (
                <div className="theme-labels">
                  <div className="theme-label">
                    {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value'], '')}
                  </div>
                  {entity.getIn(['field_theme']).size > 1 && (
                    <div className="theme-label">
                      +{entity.getIn(['field_theme']).size - 1}
                    </div>
                  )}
                </div>
              ) : null}
              <span>{i18next.t('download')}</span>
            </div>
          </div>
          <h2>{entity.getIn(['title', 0, 'value'])}</h2>
          {entity.getIn(['body', 0, 'processed']) ? (
            <WysiwygField
              property="schema:text"
              className="node--page--body font-size--body--large"
              html={entity.getIn(['body', 0, 'processed'], '')}
            />
          ) : null}
        </div>
      </div>
    </article>
  );
};

export default DownloadTeaserLarge;
